
import React from 'react';

import ReactDOM from 'react-dom';
import { Layout } from 'element-react';
import FeasComponents from '../render/FeasComponents.js'
 

import KeeVue from '../base/KeeVue.js'
 
export default class FsCol extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			isShow: false,
			randId: this.getRandString(),

		}

	}

	componentWillMount() {
		var that = this;
		this.registComponent();

	}

	onCommand=(cmdName, item, po, thisForm, parentForm)=> {
		this.$emit("command", cmdName, item, po, thisForm, parentForm);
	}
	onChanged=(ret)=> {
		this.$emit("changed", ret);
	}

	render() {
	 
		var style = JSON.parse(JSON.stringify(this.props.component.style));
		// 强制col的display为block
		style.display="block";
		return (

			<div style={style}>
				{
					this.props.component.child && this.props.component.child.length > 0 && <FeasComponents components={this.props.component.child} 
					query={this.props.query}
					keePage={this.props.keePage} 
						parentViewName={this.props.parentViewName} po={this.props.po} 
						thisForm={this.props.thisForm} parentForm={this.props.parentForm} 
					name={this.props.name} debug={this.props.debug}
					editable={this.props.editable} 
					onchanged={this.onChanged}
					onCommand={this.onCommand}
					></FeasComponents>
				}

			</div>

		);
	}
}
